export enum ApplyChangeType {
  Time = 2,
  Credit = 1,
}

export enum ChangeStatus {
  APPLYING = 10, //申请中
  AGREE = 20, //同意
  REFUSE = 30, //拒绝
  CANCEL = 40, //撤销
}

export type ChangeListItem = {
  changeApplyId: number;
  parentTaskId: number;
  taskSubject: string;
  applyType: ApplyChangeType;
  applyValue: string;
  applyReason: string;
  applyUserId: number;
  status: ChangeStatus;
  fromAllocator: boolean;
  allowRevoke: boolean;
  activityId?: number;
};
